import { render, staticRenderFns } from "./ExamImg.vue?vue&type=template&id=7c526301&scoped=true"
import script from "./ExamImg.vue?vue&type=script&lang=js"
export * from "./ExamImg.vue?vue&type=script&lang=js"
import style0 from "./ExamImg.vue?vue&type=style&index=0&id=7c526301&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c526301",
  null
  
)

export default component.exports